exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-line>span[data-v-c7d497c0]:first-child{text-align:start}.info-line>span[data-v-c7d497c0]:nth-child(2){text-align:end}", ""]);

// exports
